import { RemixPage } from '~/utils/remix-page';
import { ArticleBody } from './body/index';
import { ArticleHead } from './head/index';
import { LinksFunction } from '@remix-run/react/dist/routeModules';
import { cssLinks } from '@ttark/css-links';
import { ShouldRevalidateFunction } from '@remix-run/react';
import { LoaderFunction } from '@remix-run/node';
import { buildMasterLoader } from '~/utils/build-master-loader';

export const links: LinksFunction = () => [...(cssLinks as any)('routes/$user_link_name_.$article_id')];

export const loader: LoaderFunction = buildMasterLoader('article');

export const shouldRevalidate: ShouldRevalidateFunction = (args) => {
  const {
    currentParams: { user_link_name: currentUserLinkName, article_id: currentArticleId },
    nextParams: { user_link_name: userLinkName, article_id: articleId },
    defaultShouldRevalidate,
  } = args;

  if (currentUserLinkName === userLinkName && currentArticleId === articleId) {
    console.log('[shouldRevalidate] same route, skip revalidate');
    return false;
  }

  return defaultShouldRevalidate;
};

export default class ArticlePage extends RemixPage {
  Head = ArticleHead;

  Body = ArticleBody;
}
